import React, { useEffect, useState } from "react";
import { Wrapper } from "../../components/Wrapper";
import { PageTitle } from "../../components/PageTitle";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Notification } from "../../utils/Notification";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/Button";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Preload } from "../../components/Preload";
import { Selected } from "../../components/Form/Selected";
import { useMutation, useQuery } from "@apollo/client";
import i18next from "i18next";
import { TextInput } from "../../components/Form/TextInput";
import { GET_BLACK_LIST } from "../../graphql/Queries/BlackListQuery";
import { MODIFY_BLACK_LIST } from "../../graphql/Mutations/BlackListMutation";
import { FileInput } from "../../components/Form/FileInput";

export const FormBlackList = ({ url }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let location = useLocation();
  const id = location.state ? location.state.id : null;
  let [searchParams, setSearchParams] = useSearchParams();
  const [modify] = useMutation(MODIFY_BLACK_LIST);
  const { data } = useQuery(GET_BLACK_LIST, {
    variables: {
      id: Number(searchParams.get("id")),
      lang: i18next.language,
    },
    fetchPolicy: "no-cache",
  });
  const formik = useFormik({
    initialValues: {
      id: 0,
      phone: "",
      type: 1,
      locked_at: 1,
      comment: "",
      files: [],
    },
    validationSchema: Yup.object({
      phone: Yup.string().required(t("Объязательное поле")),
    }),
    onSubmit: (values) => {
      setLoading(true);
      modify({
        variables: {
          id: Number(values.id),
          phone: values.phone,
          type: Number(values.type),
          locked_at: Number(values.locked_at),
          comment: values.comment,
          files: JSON.stringify(values.files),
        },
      })
        .then((response) => {
          if (!response.data.modifyBlackList) {
            Notification(t("Указаный номер уже добавлен"));
          } else {
            navigate(url);
            Notification(t("Все хорошо!"), "success");
          }
        })
        .catch((error) => {
          Notification(error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });
  const [endLock, setEndLock] = useState(null);

  useEffect(() => {
    if (data && data.blackList[0]) {
      formik.setFieldValue("id", data.blackList[0].id);
      formik.setFieldValue("phone", data.blackList[0].phone);
      formik.setFieldValue("type", Number(data.blackList[0].type));
      formik.setFieldValue("comment", data.blackList[0].comment);
      setEndLock(data.blackList[0].locked_at);
    }
  }, [data]);

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle
        title={
          id === null
            ? "Добавить в черный список"
            : "Редактировать черный список"
        }
        breadcrumbs={[
          {
            slug: url,
            name: "Черный список",
          },
        ]}
      />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form className="row" onSubmit={formik.handleSubmit}>
                <div className={"col-md-12"}>
                  <div className={"alert alert-info"}>
                    {t(
                      "История блокировок не сохраняется, поэтому при смене статуса или длительности блокировки важно учитывать выборки.",
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <TextInput
                    label={"Телефон"}
                    value={formik.values.phone}
                    onChange={(e) => {
                      formik.setFieldValue(`phone`, e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.errors.phone}
                    name={"phone"}
                  />
                </div>
                <div className="col-md-6">
                  <Selected
                    label={"Тип"}
                    onChange={(value) => {
                      formik.setFieldValue(`type`, value);
                    }}
                    error={formik.errors.type}
                    name={"type"}
                    rows={{ value: "id", label: "name" }}
                    staticOptions={data?.list}
                    value={formik.values.type}
                  />
                </div>
                <div className="col-md-6">
                  <Selected
                    label={"Тип блокировки"}
                    onChange={(value) => {
                      formik.setFieldValue(`locked_at`, value);
                    }}
                    error={formik.errors.locked_at}
                    name={"locked_at"}
                    staticOptions={[
                      { id: 1, name: t("1 день") },
                      { id: 2, name: t("5 дней") },
                      { id: 3, name: t("30 дней") },
                      { id: 4, name: t("1 год") },
                      { id: 5, name: t("Навсегда") },
                    ]}
                    rows={{ value: "id", label: "name" }}
                    value={formik.values.locked_at}
                  />
                </div>
                {data?.blackList[0] &&
                  Number(data?.blackList[0].user_id) > 0 && (
                    <div className="col-md-6">
                      <div>
                        <strong>{t("ID пользователя")}:</strong>{" "}
                        {data?.blackList[0].user_id}
                      </div>
                      <div>
                        <strong>{t("Дата завершения блокировки")}:</strong>{" "}
                        {endLock === null ? t("На всегда") : endLock}
                      </div>
                    </div>
                  )}
                <div className="col-md-12">
                  <TextInput
                    label={"Комментарий"}
                    value={formik.values.comment}
                    onChange={(event) => {
                      formik.setFieldValue(`comment`, event.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.errors.comment}
                    touched={formik.touched.comment}
                    name={"comment"}
                  />
                </div>
                <div className="col-md-12">
                  <FileInput
                    label={"Фото"}
                    onChange={(file, lang) => {
                      let _image = [];
                      if (formik.values.files) {
                        _image = [...formik.values.files];
                      }
                      _image.push(file);
                      formik.setFieldValue(`files`, _image);
                    }}
                    value={formik.values.files}
                    multilang={false}
                    onDelete={() => {
                      formik.setFieldValue("files", []);
                    }}
                  />
                </div>
                <div
                  className="col-md-12 text-center"
                  style={{ marginTop: 20 }}
                >
                  <Button
                    label={"Сохранить"}
                    loading={loading}
                    style={"btn btn-primary w-md"}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
